import { cloudTiers } from '@ipfabric/utils/license/baseCloudConstruct';
import classNames from 'classnames';
import type { SnapshotLicenseUsageValue } from 'pages/SnapshotManagement/toSnapshotLicenseUsage';
import type { FC, ReactNode } from 'react';
import { licenseSectionClassName } from './LicenseSectionsGrid';
import { TIER_LABELS, formatTierCost } from './licenseBreakdownData';

/** How much a construct of each tier costs, built from `cloudTierPricing`. */
const CCU_MODEL_NOTE = `${cloudTiers
  .map((tier) => `${TIER_LABELS[tier]} = ${formatTierCost(tier)}`)
  .join(' | ')}.`;

export type CloudLicenseSectionProps = {
  cloud: SnapshotLicenseUsageValue['cloud'];
  /** The construct type breakdown, or its loading / error state. */
  children: ReactNode;
  className?: string;
};

/** Cloud license consumption in CCU: summary per tier plus the construct type breakdown. */
export const CloudLicenseSection: FC<CloudLicenseSectionProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames(licenseSectionClassName, className)}>
      <div className='flex flex-col gap-xs'>
        <h2 className='m-none font-semibold text-default text-level-5'>
          Cloud
        </h2>
        <p className='m-none text-sm text-muted'>{CCU_MODEL_NOTE}</p>
      </div>
      {children}
    </div>
  );
};
